import { Badge } from "@/components/ui/badge";
import { statusLabel } from "@/lib/status";

const STYLES = {
  open: "bg-volt-soft text-volt border-volt/20",
  aperto: "bg-volt-soft text-volt border-volt/20",
  aperta: "bg-volt-soft text-volt border-volt/20",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  in_attesa: "bg-amber-50 text-amber-700 border-amber-200",
  domande: "bg-amber-50 text-amber-700 border-amber-200",
  needs_clarification: "bg-amber-50 text-amber-700 border-amber-200",
  assigned: "bg-amber-50 text-amber-700 border-amber-200",
  professionista_scelto: "bg-amber-50 text-amber-700 border-amber-200",
  in_progress: "bg-volt-soft text-volt border-volt/20",
  in_corso: "bg-volt-soft text-volt border-volt/20",
  in_viaggio: "bg-volt-soft text-volt border-volt/20",
  arrivato: "bg-volt-soft text-volt border-volt/20",
  iniziato: "bg-volt-soft text-volt border-volt/20",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  risolto: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  canceled: "bg-slate-100 text-slate-500 border-slate-200",
  annullato: "bg-slate-100 text-slate-500 border-slate-200",
  closed: "bg-slate-100 text-slate-500 border-slate-200",
  accettata: "bg-emerald-50 text-emerald-700 border-emerald-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rifiutata: "bg-slate-100 text-slate-500 border-slate-200",
  rejected: "bg-slate-100 text-slate-500 border-slate-200",
};

export function StatusBadge({ status, testid }) {
  if (!status) return null;
  return (
    <Badge data-testid={testid} variant="outline" className={`font-semibold rounded-full whitespace-nowrap ${STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {statusLabel(status)}
    </Badge>
  );
}
